import type { BoxProps } from '../box/box';
import { Box } from '../box/box';

type FormProps = Pick<
  BoxProps,
  | 'children'
  | 'spacing'
  | 'padding'
  | 'title'
  | 'Component'
  | 'method'
  | 'autoComplete'
> & {
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;
};

export const Form = ({ Component = 'form', ...props }: FormProps) => (
  <Box Component={Component} {...props} />
);
